<template>
  <div v-if="data.rows.length>limit">
    Warning : Large volume of data ahead (> {{ limit }}), can't render chart. Sorry.
  </div>
  <apexchart
    v-else
    :type="options['General']?options['General']['Chart Type'].value:'bar'"
    width="100%"
    height="95%"
    :options="chart_options"
    :series="series"
  />
</template>

<script>
  import {
    VIZ_CONFIGS,
  } from './../constants/VisualizationConfigs'
  import VueApexCharts from 'vue-apexcharts'
  export default {
    components: {
      'apexchart': VueApexCharts,
    },
    props: {
      data: {
        required: true,
        type: Object,
        default: () => {
          return {
            columns: [],
            rows: [],
          }
        },
      },
      options: {
        required: false,
        type: Object,
        default: () => {
          return VIZ_CONFIGS.chart
        },
      },
    },
    data () {
      return {
        limit: 10000,
      }
    },
    computed: {
      series () {
        let data = []
        if (this.data.rows.length > this.limit) { return true }
        if (this.options['General']) {
          let chartType = this.options['General']['Chart Type'].value
          let xCol = this.options['General']['X Column'].value
          let yCols = this.options['General']['Y Columns'].value
          if (yCols.length <= 0) { return [] }

          if (['pie', 'donut'].includes(chartType)) {
            data = _.map(this.data.rows, yCols[0])
          } else {
            if (typeof xCol === 'object') {
              _.map(xCol, col => {
                data.push({
                  name: col,
                  data: _.map(this.data.rows, col),
                })
              })
            } else {
              let xGroups = _.uniq(_.map(this.data.rows, xCol))
              _.map(yCols, yCol => {
                let temp = { data: [] }

                _.map(xGroups, xGroup => {
                  let temp_data = {
                    x: xGroup,
                    y: [],
                  }
                  this.data.rows.forEach(row => {
                    if (row[xCol] == xGroup) {
                      if (row[yCol] == null) { temp_data.y.push(0) } else {
                        temp_data.y.push(typeof row[yCol] === 'string' ? _.toNumber(row[yCol].replace(/[^\d.\,\s]+/gi, '')) : row[yCol])
                      }
                    }
                  })
                  temp.data.push(temp_data)
                })
                data.push(temp)
              })
            }
          }
        }

        return data
      },
      chart_options () {
        let chartType = this.options['General'] ? this.options['General']['Chart Type'].value : 'bar'
        // let yCol = this.options['General']?this.options['General']['Y Column'].value:''
        if (_.isEmpty(this.options)) { return {} }
        let xCol = this.options['General']['X Column'].value
        let options = {}
        if (['pie', 'donut'].includes(chartType)) {
          options.labels = _.map(this.data.rows, xCol)
        }
        options.theme = {
          mode: 'light',
          palette: 'palette1',
        }

        return options
      },
    },
    watch: {
      data (n, o) {
      },
    },
    mounted () {
    },

  }
</script>

<style scoped>

</style>
